<script>
    import Vue from 'vue';
    import { mapActions, mapGetters } from 'vuex';
    import dayjs from 'dayjs';

    import Step1FlightConfig from './Step1FlightConfig.vue'; // Step 1
    import Step2DateConfig from './Step2DateConfig.vue'; // Step 2
    import Step3RouteConfig from './Step3RouteConfig.vue'; // Step 3

    import StepperHeader from './StepperHeader.vue';
    import ActionBar from './ActionBar.vue';
    import { eventBus } from '../../../../../../../main';


    export default {
        name: 'BottomSheet', // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
		components: {

            'sdr-step1-flightconfig': Step1FlightConfig,
            'sdr-step2-dateconfig': Step2DateConfig,
            'sdr-step3-routeconfig': Step3RouteConfig,
            'sdr-stepper-header': StepperHeader,
            'sdr-stepper-action-bar': ActionBar

		},

        /* >>> *************************************************************** / /* Props */
        props: {

            value: [Boolean], // 'showSheet' itself
            editorMode: String, // 'update', 'create', 'extend'
            editorFlightLegMode: String, // 'single', 'rotation'
            eventRecord: Object // 'update'

        }, // eo components{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> ------------------------------------ 'Form Validation Rules'
                valid: false,
                rules: {
                    req(v) {
                        return (v || '').toString().length > 0 || 'Field is required';
                    },
                    min(min, v) {
                        return (v === null || v === '' || v === undefined) || v.length >= min || `Length must be at least ${min}`;
                    },
                    max(max, v) {
                        return (v || '').length <= max || `Length may not be greater than ${max}.`;
                    },
                    reqIfWeekly(v, flightDateType) {
                        return flightDateType === 0 || v === 0 || (v || '').toString().length > 0 || 'Field is required';
                    },
                    reqIfActiveTab(v, isActiveTab) {
                        return isActiveTab === false || (v || '').toString().length > 0 || 'Field is required';
                    },
                    isFlightNo(v) {
                        return (v === null || v === '' || v === undefined) || /^[A-Za-z0-9]{1,3}\d{1,4}[a-z]{0,1}$/i.test(v) || 'Invalid Flight#';
                    }
                },
                // >>> ------------------------------------ 'CRUD Config'
                crudData: {
                    firstLeg: {
                        input_FlightId: '',
                        // >>> Step 1: 'Flight Config' --------------
                        input_AircraftConfig: '',
                        input_FlightModus: null,
                        input_CodeShare: '',
                        input_Range: 'SHORT',
                        input_ServiceFlags: [],
                        input_FlightComment: '',
                        input_Comment: '', // old
                        input_PermissionNumber: '',
                        input_MainServiceType: '',

                        // >>> Step 2: 'Date Config' ----------------
                        input_FlightDateType: 0,
                        input_weekly_DaysOfWeek: [],
                        input_dates_dates: [],
                        input_weekly_StartDate: '',
                        input_weekly_EndDate: '',
                        input_weekly_NumberOfWeeks: [],

                        weekly_datesInRange: {
                            total: 0,
                            weeks: 0,
                            dates: [],
                            months: []
                        },

                        // >>> Step 3: 'Route Config' ---------------
                        input_FlightTypeTab: 0,
                        input_directFlight_FlightNo: '', // directFlight
                        input_directFlight_AtcCallSign: '',
                        input_directFlight_AirportDeparture: '',
                        input_directFlight_AirportDestination: '',

                        input_viaFlight_FlightNo: '', // viaFlight
                        input_viaFlight_AtcCallSign: '',
                        input_viaFlight_AirportDeparture: '',
                        input_viaFlight_AirportVia: '',
                        input_viaFlight_AirportDestination: '',

                        input_triaFlight_FlightNo: '', // triaFlight
                        input_triaFlight_AtcCallSign: '',
                        input_triaFlight_FlightNoVia: '',
                        input_triaFlight_AtcCallSignVia: '',
                        input_triaFlight_AirportDestinationDeparture: '',
                        input_triaFlight_AirportFirstVia: '',
                        input_triaFlight_AirportSecondVia: '',

                        input_AB_Time_Departure_Actual: null, // >>> --- AB
                        input_AB_Time_Arrival_Actual: null,
                        input_AB_Time_Departure_Scheduled: null,
                        input_AB_Time_Arrival_Scheduled: null,
                        input_AB_Slot_Departure: null,
                        input_AB_Slot_Arrival: null,
                        input_AB_Departure_SlotStatus: null,
                        input_AB_Arrival_SlotStatus: null,

                        input_BC_Time_Departure_Actual: null, // >>> --- BC
                        input_BC_Time_Arrival_Actual: null,
                        input_BC_Time_Departure_Scheduled: null,
                        input_BC_Time_Arrival_Scheduled: null,
                        input_BC_Slot_Departure: null,
                        input_BC_Slot_Arrival: null,
                        input_BC_Departure_SlotStatus: null,
                        input_BC_Arrival_SlotStatus: null,

                        input_CA_Time_Departure_Actual: null, // >>> --- CA
                        input_CA_Time_Arrival_Actual: null,
                        input_CA_Time_Departure_Scheduled: null,
                        input_CA_Time_Arrival_Scheduled: null,
                        input_CA_Slot_Departure: null,
                        input_CA_Slot_Arrival: null,
                        input_CA_Departure_SlotStatus: null,
                        input_CA_Arrival_SlotStatus: null,

                        input_overnight: false, // >>> --- OVERNIGHT

                        input_Switch_FlightOverNight: false, // >>> --- SWITCHES
                        input_Switch_CheckIn: false,
                        input_Switch_CheckOut: false,

                        input_idStartSegment: null // >>> --- FlightGroud
                    },
                    secondLeg: {
                        // >>> Step 1: 'Flight Config' --------------
                        input_AircraftConfig: '',
                        input_FlightModus: null,
                        input_CodeShare: '',
                        input_Range: 'SHORT',
                        input_ServiceFlags: [],
                        input_FlightComment: '',
                        input_Comment: '', // old
                        input_PermissionNumber: '',
                        input_MainServiceType: '',

                        // >>> Step 2: 'Date Config' ----------------
                        input_FlightDateType: 0,
                        input_weekly_DaysOfWeek: [],
                        input_dates_dates: [],
                        input_weekly_StartDate: '',
                        input_weekly_EndDate: '',
                        input_weekly_NumberOfWeeks: [],

                        weekly_datesInRange: {
                            total: 0,
                            weeks: 0,
                            dates: [],
                            months: []
                        },

                        // >>> Step 3: 'Route Config' ---------------
                        input_FlightTypeTab: 0,
                        input_directFlight_FlightNo: '', // directFlight
                        input_directFlight_AtcCallSign: '',
                        input_directFlight_AirportDeparture: '',
                        input_directFlight_AirportDestination: '',

                        input_viaFlight_FlightNo: '', // viaFlight
                        input_viaFlight_AtcCallSign: '',
                        input_viaFlight_AirportDeparture: '',
                        input_viaFlight_AirportVia: '',
                        input_viaFlight_AirportDestination: '',

                        input_triaFlight_FlightNo: '', // triaFlight
                        input_triaFlight_AtcCallSign: '',
                        input_triaFlight_FlightNoVia: '',
                        input_triaFlight_AtcCallSignVia: '',
                        input_triaFlight_AirportDestinationDeparture: '',
                        input_triaFlight_AirportFirstVia: '',
                        input_triaFlight_AirportSecondVia: '',

                        input_AB_Time_Departure_Actual: null, // >>> --- AB
                        input_AB_Time_Arrival_Actual: null,
                        input_AB_Time_Departure_Scheduled: null,
                        input_AB_Time_Arrival_Scheduled: null,
                        input_AB_Slot_Departure: null,
                        input_AB_Slot_Arrival: null,

                        input_BC_Time_Departure_Actual: null, // >>> --- BC
                        input_BC_Time_Arrival_Actual: null,
                        input_BC_Time_Departure_Scheduled: null,
                        input_BC_Slot_Departure: null,
                        input_BC_Time_Arrival_Scheduled: null,
                        input_BC_Slot_Arrival: null,

                        input_CA_Time_Departure_Actual: null, // >>> --- CA
                        input_CA_Time_Arrival_Actual: null,
                        input_CA_Time_Departure_Scheduled: null,
                        input_CA_Time_Arrival_Scheduled: null,
                        input_CA_Slot_Departure: null,
                        input_CA_Slot_Arrival: null,

                        input_overnight: false, // >>> --- OVERNIGHT

                        input_Switch_FlightOverNight: false, // >>> --- SWITCHES
                        input_Switch_CheckIn: false,
                        input_Switch_CheckOut: false,

                        input_nextDay: false
                    },
                    missingBlocktimes: []
                },
                // >>> ------------------------------------ 'Form Stepper'
                formStepper: 3,
                // >>> ------------------------------------ 'Stepper Errors'
                validation: { step1: true, step2: true, step3: true },
                activeStepper: '3',
                // >>> 15.03.2022 - CAR<christian.arp@sundair.com>: #194
                // >>> ------------------------------------ 'Utils'
                sheetAlreadyOpen: false
                // <<< 15.03.2022 - CAR<christian.arp@sundair.com>: #194
            };

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_OCCMode',
                'get_flights_lastDateOfSimilarFlights',
                'get_Blocktimes',
                'get_similarFlights',
                'get_Shared_isUserAllowedToUse'
            ]),


            /*******************************************************************
            * sheetShown{}
            *
            * Desc:
            * Note:
            *
            */
            sheetShown: {

                get() {
                    const me = this,
                          eventRecord = me.eventRecord;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/sheetShown/get');
                    // >>> 15.03.2022 - CAR<christian.arp@sundair.com>: #194
                    if (me.value === true && me.sheetAlreadyOpen === false) { // we're opening so initialize data
                    // <<< 15.03.2022 - CAR<christian.arp@sundair.com>: #194

                        // >>> 15.03.2022 - CAR<christian.arp@sundair.com>: #194
                        // remember that the sheet is opened and INITIALIZED
                        me.sheetAlreadyOpen = true;
                        // <<< 15.03.2022 - CAR<christian.arp@sundair.com>: #194

                        // >>> ------------------ reset validation
                        if (me.$refs.form !== undefined) {
                            me.$refs.form.resetValidation();
                        }

                    }

                    // >>> 15.03.2022 - CAR<christian.arp@sundair.com>: #194
                    // on closing the sheet, reset the util variables too
                    if (me.value === false) {
                        me.sheetAlreadyOpen = false;
                    }
                    // <<< 15.03.2022 - CAR<christian.arp@sundair.com>: #194


                    return this.value;

                }, // eo function sheetShown get()


                set(value) {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/sheetShown/set');
                    this.$emit('input', value);

                } // eo function sheetShown set()

            } // eo sheetShown{}

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            const me = this;


            me.$toc('>>> views/shared/components/core/BottomSheet.vue >>> created');

            eventBus.$on('validationSelectedFlightsChange', me.onEmit_forceStepperHeaderChange);

        }, // eo function created()
        /* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        destroyed: function() {

            const me = this;


            me.$toc('>>> views/shared/components/core/BottomSheet.vue >>> destroyed');

            eventBus.$off('validationSelectedFlightsChange', me.onEmit_forceStepperHeaderChange);

        }, //eo function created()
        /* <<< ****************************************************************/



        /* >>> ***************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_set_warning',
                'actn_call_slotmanagement_updateFlights',
                'actn_call_updateCreateBlocktimes'
            ]),


            //---------------------------------------------------------------------/
            // #
            // #    /$$$$$$                                                   /$$
            // #   /$$__  $$                                                 | $$
            // #  | $$  \__/  /$$$$$$  /$$$$$$$   /$$$$$$   /$$$$$$  /$$$$$$ | $$
            // #  | $$ /$$$$ /$$__  $$| $$__  $$ /$$__  $$ /$$__  $$|____  $$| $$
            // #  | $$|_  $$| $$$$$$$$| $$  \ $$| $$$$$$$$| $$  \__/ /$$$$$$$| $$
            // #  | $$  \ $$| $$_____/| $$  | $$| $$_____/| $$      /$$__  $$| $$
            // #  |  $$$$$$/|  $$$$$$$| $$  | $$|  $$$$$$$| $$     |  $$$$$$$| $$
            // #   \______/  \_______/|__/  |__/ \_______/|__/      \_______/|__/
            // #
            //--------------------------------------------------------------------/
            /*******************************************************************
            * Listeners
            *******************************************************************/
            /*******************************************************************
            * onChange_StepperHeader
            *
            * Desc:
            * Note:
            *
            */
            onChange_StepperHeader: function(stepperNumber) {

                const me = this;


                me.$toc('>>> views/shared/components/core/BottomSheet.vue >>> onChange_StepperHeader');
                if (stepperNumber === '4') {
                    me.validateFormStepper('1');
                    me.validateFormStepper('2');
                    me.validateFormStepper('3');
                }
                me.onClick_StepperHeader(stepperNumber);

            }, // eo function onChange_StepperHeader()

            /*******************************************************************
            * onEmit_forceStepperHeaderChange
            *
            * Desc: Forces a step change after selecting multiple flights (emit @ BottomSheetUpdate.vue Row 942)
            * Note: Rule: e.g. you can't edit Step 3 if you selected multiple flights on same day
            * Note: ... so if you stand on Step 3, we change the Step to an editable Step instead
            *
            */
            onEmit_forceStepperHeaderChange: function(validationSelectedFlights) {

                const me = this;

                if (me.editorMode === 'update') {

                    if (me.activeStepper === '3' && validationSelectedFlights.step3IsEditable === false) {

                        me.activeStepper = '2';
                        me.formStepper = 2;
                    }

                    if (me.activeStepper === '2' && validationSelectedFlights.step2IsEditable === false) {

                        me.activeStepper = '1';
                        me.formStepper = 1;
                    }
                }

            }, // eo function onEmit_forceStepperHeaderChange()


            /*******************************************************************
            * onClick_CloseSheet()
            *
            * Desc:
            * Note:
            *
            */
            onClick_CloseSheet: function() {

                const me = this;


                me.$toc('>>> views/shared/components/core/BottomSheet.vue >>> onClick_CloseSheet');
                me.sheetShown = false;

            }, // eo onClick_CloseSheet()


            /*******************************************************************
            * onChange_TabChange()
            *
            * Desc: Resets the rules state on tab change. (Step2RouteConfig + Step3RouteConfig)
            * Note:
            *
            */
            onChange_TabChange: function() {

                const me = this;


                me.$toc('>>> views/shared/components/core/BottomSheet.vue >>> onChange_TabChange');
                me.$refs.form.resetValidation();

            }, // eof onChange_TabChange()


            /*******************************************************************
            * onFocus_setFocusedInput()
            *
            * Desc: Listens to the focused field and gives the input
            * Note:
            *
            */
            onFocus_setFocusedInput: function(focusedInput) {

                const me = this;


                me.$toc('>>> views/shared/components/core/BottomSheet.vue >>> onFocus_setFocusedInput');
                eventBus.$emit('focusedInputChanged', focusedInput);

            }, // eof onFocus_setFocusedInput()


            //-----------------------------------------------------------------/
            // #
            // #  /$$   /$$                 /$$             /$$
            // # | $$  | $$                | $$            | $$
            // # | $$  | $$  /$$$$$$   /$$$$$$$  /$$$$$$  /$$$$$$    /$$$$$$
            // # | $$  | $$ /$$__  $$ /$$__  $$ |____  $$|_  $$_/   /$$__  $$
            // # | $$  | $$| $$  \ $$| $$  | $$  /$$$$$$$  | $$    | $$$$$$$$
            // # | $$  | $$| $$  | $$| $$  | $$ /$$__  $$  | $$ /$$| $$_____/
            // # |  $$$$$$/| $$$$$$$/|  $$$$$$$|  $$$$$$$  |  $$$$/|  $$$$$$$
            // #  \______/ | $$____/  \_______/ \_______/   \___/   \_______/
            // #           | $$
            // #           | $$
            // #           |__/
            // #
            //-----------------------------------------------------------------/
            /*******************************************************************
            * onAssign_Update()
            *
            * Desc: Assign Object in/for 'update' Mode.
            * Note:
            *
            */
            onAssign_Update: function(eventRecord) {

                const me = this;


                me.$toc('>>> views/shared/components/core/BottomSheet.vue >>> onAssign_Update');
                Object.assign(me, {
                    // >>> ------------------------------------ 'CRUD Config'
                    crudData: {
                        firstLeg: {
                            input_FlightId: eventRecord.firstLeg.idFlight,
                            // >>> Step 1: 'Flight Config' --------------
                            input_AircraftConfig: eventRecord.firstLeg.idAircraftConfig,
                            input_FlightModus: eventRecord.firstLeg.flightModus,
                            input_CodeShare: eventRecord.firstLeg.codeshare,
                            input_Range: eventRecord.firstLeg.routeLength,
                            input_ServiceFlags: this.setServiceFlags(eventRecord.firstLeg),
                            input_FlightComment: eventRecord.firstLeg.flightComment,
                            input_Comment: eventRecord.firstLeg.flightComment, // old
                            input_PermissionNumber: eventRecord.firstLeg.permissionNumber,
                            input_MainServiceType: eventRecord.firstLeg.mainServiceType,

                            // >>> Step 2: 'Date Config' ----------------
                            input_FlightDateType: 0, // not needed as we only edit single flights / dates
                            input_weekly_DaysOfWeek: [], // not needed as we only edit single flights / dates
                            input_dates_dates: eventRecord.firstLeg.dates, // TODO: ???
                            input_weekly_StartDate: '', // not needed as we only edit single flights / dates
                            input_weekly_EndDate: '', // not needed as we only edit single flights / dates
                            input_weekly_NumberOfWeeks: [], // not needed as we only edit single flights / dates

                            weekly_datesInRange: { // not needed as we only edit single flights / dates
                                total: 0,
                                weeks: 0,
                                dates: [],
                                months: []
                            },

                            // >>> Step 3: 'Route Config' ---------------
                            input_FlightTypeTab: eventRecord.firstLeg.flightTypeTab.firstLeg,
                            input_directFlight_FlightNo: eventRecord.firstLeg.flightNo, // directFlight
                            input_directFlight_AtcCallSign: eventRecord.firstLeg.atcCallSign,
                            input_directFlight_AirportDeparture: eventRecord.firstLeg.aptFrom,
                            input_directFlight_AirportDestination: eventRecord.firstLeg.aptTo,

                            // not needed as we only edit single flights / dates
                            input_viaFlight_FlightNo: eventRecord.firstLeg.flightNo, // viaFlight
                            input_viaFlight_AtcCallSign: eventRecord.firstLeg.atcCallSign,
                            input_viaFlight_AirportDeparture: eventRecord.firstLeg.aptFrom,
                            input_viaFlight_AirportVia: eventRecord.firstLeg.aptVIA,
                            input_viaFlight_AirportDestination: eventRecord.firstLeg.aptTo, // reversed to keep code simple TODO:

                            // not needed as we only edit single flights / dates
                            input_triaFlight_FlightNo: eventRecord.firstLeg.flightNo, // triaFlight
                            input_triaFlight_AtcCallSign: eventRecord.firstLeg.atcCallSign,
                            input_triaFlight_FlightNoVia: eventRecord.firstLeg.flightNoVia,
                            input_triaFlight_AtcCallSignVia: eventRecord.firstLeg.atcCallSignVia,
                            input_triaFlight_AirportDestinationDeparture: eventRecord.firstLeg.aptFrom,
                            input_triaFlight_AirportFirstVia: eventRecord.firstLeg.aptVIA,
                            input_triaFlight_AirportSecondVia: eventRecord.firstLeg.airportSecondVIA,


                            input_AB_Time_Departure_Actual: eventRecord.firstLeg.AB_departureTime ? dayjs(eventRecord.firstLeg.departureTime).utc().format('HH:mm') : null, // >>> --- AB
                            input_AB_Time_Arrival_Actual: eventRecord.firstLeg.arrivalTime ? dayjs(eventRecord.firstLeg.arrivalTime).utc().format('HH:mm') : null,
                            input_AB_Time_Departure_Scheduled: eventRecord.firstLeg.dep_sch_time ? dayjs(eventRecord.firstLeg.dep_sch_time).utc().format('HH:mm') : null,
                            input_AB_Time_Arrival_Scheduled: eventRecord.firstLeg.arr_sch_time ? dayjs(eventRecord.firstLeg.arr_sch_time).utc().format('HH:mm') : null,
                            input_AB_Slot_Departure: eventRecord.firstLeg.dep_slt_time ? dayjs(eventRecord.firstLeg.dep_slt_time).utc().format('HH:mm') : null,
                            input_AB_Slot_Arrival: eventRecord.firstLeg.arr_slt_time ? dayjs(eventRecord.firstLeg.arr_slt_time).utc().format('HH:mm') : null,
                            input_AB_Departure_SlotStatus: eventRecord.firstLeg.depSlotStatus,
                            input_AB_Arrival_SlotStatus: eventRecord.firstLeg.arrSlotStatus,

                            // not needed as we only edit single flights / dates
                            input_BC_Time_Departure_Actual: eventRecord.firstLeg.BC_departureTime ? dayjs(eventRecord.firstLeg.BC_departureTime).utc().format('HH:mm') : null, // >>> --- BC
                            input_BC_Time_Arrival_Actual: eventRecord.firstLeg.BC_arrivalTime ? dayjs(eventRecord.firstLeg.BC_arrivalTime).utc().format('HH:mm') : null,
                            input_BC_Time_Departure_Scheduled: eventRecord.firstLeg.BC_dep_sch_time ? dayjs(eventRecord.firstLeg.BC_dep_sch_time).utc().format('HH:mm') : null,
                            input_BC_Time_Arrival_Scheduled: eventRecord.firstLeg.BC_arr_sch_time ? dayjs(eventRecord.firstLeg.BC_arr_sch_time).utc().format('HH:mm') : null,
                            input_BC_Slot_Departure: eventRecord.firstLeg.BC_dep_slt_time ? dayjs(eventRecord.firstLeg.BC_dep_slt_time).utc().format('HH:mm') : null,
                            input_BC_Slot_Arrival: eventRecord.firstLeg.BC_arr_slt_time ? dayjs(eventRecord.firstLeg.BC_arr_slt_time).utc().format('HH:mm') : null,
                            input_BC_Departure_SlotStatus: eventRecord.firstLeg.BC_depSlotStatus,
                            input_BC_Arrival_SlotStatus: eventRecord.firstLeg.BC_arrSlotStatus,

                            // not needed as we only edit single flights / dates
                            input_CA_Time_Departure_Actual: eventRecord.firstLeg.CA_departureTime ? dayjs(eventRecord.firstLeg.CA_departureTime).utc().format('HH:mm') : null, // >>> --- BC
                            input_CA_Time_Arrival_Actual: eventRecord.firstLeg.CA_arrivalTime ? dayjs(eventRecord.firstLeg.CA_arrivalTime).utc().format('HH:mm') : null,
                            input_CA_Time_Departure_Scheduled: eventRecord.firstLeg.CA_dep_sch_time ? dayjs(eventRecord.firstLeg.CA_dep_sch_time).utc().format('HH:mm') : null,
                            input_CA_Time_Arrival_Scheduled: eventRecord.firstLeg.CA_arr_sch_time ? dayjs(eventRecord.firstLeg.CA_arr_sch_time).utc().format('HH:mm') : null,
                            input_CA_Slot_Departure: eventRecord.firstLeg.CA_dep_slt_time ? dayjs(eventRecord.firstLeg.CA_dep_slt_time).utc().format('HH:mm') : null,
                            input_CA_Slot_Arrival: eventRecord.firstLeg.CA_arr_slt_time ? dayjs(eventRecord.firstLeg.CA_arr_slt_time).utc().format('HH:mm') : null,
                            input_CA_Departure_SlotStatus: eventRecord.firstLeg.CA_depSlotStatus,
                            input_CA_Arrival_SlotStatus: eventRecord.firstLeg.CA_arrSlotStatus,

                            input_overnight: eventRecord.firstLeg.overnight, // >>> --- OVERNIGHT

                            input_Switch_FlightOverNight: false, // >>> --- SWITCHES
                            input_Switch_CheckIn: false,
                            input_Switch_CheckOut: false,

                            input_idStartSegment: eventRecord.firstLeg.idStartSegment // >>> --- FlightGroup
                        },
                        secondLeg: {
                            // >>> Step 1: 'Flight Config' --------------
                            input_AircraftConfig: eventRecord.secondLeg.idAircraftConfig ? eventRecord.secondLeg.idAircraftConfig : '',
                            input_FlightModus: eventRecord.secondLeg.flightModus ? eventRecord.secondLeg.flightModus : null,
                            input_CodeShare: eventRecord.secondLeg.codeshare ? eventRecord.secondLeg.codeshare : '',
                            input_Range: eventRecord.secondLeg.routeLength ? eventRecord.secondLeg.routeLength : 'SHORT',
                            input_ServiceFlags: this.setServiceFlags(eventRecord.secondLeg) ? this.setServiceFlags(eventRecord.secondLeg) : [],
                            input_FlightComment: eventRecord.secondLeg.flightComment ? eventRecord.secondLeg.flightComment : '',
                            input_Comment: eventRecord.secondLeg.flightComment ? eventRecord.secondLeg.comment : '', // old
                            input_PermissionNumber: eventRecord.secondLeg.permissionNumber ? eventRecord.secondLeg.permissionNumber : '',
                            input_MainServiceType: eventRecord.secondLeg.mainServiceType ? eventRecord.secondLeg.mainServiceType : 'C',

                            // >>> Step 2: 'Date Config' ----------------
                            input_FlightDateType: 0,
                            input_weekly_DaysOfWeek: [],
                            input_dates_dates: eventRecord.secondLeg.dates ? eventRecord.secondLeg.dates : [],
                            input_weekly_StartDate: '',
                            input_weekly_EndDate: '',
                            input_weekly_NumberOfWeeks: [],

                            weekly_datesInRange: {
                                total: 0,
                                weeks: 0,
                                dates: [],
                                months: []
                            },

                            // >>> Step 3: 'Route Config' ---------------
                            input_FlightTypeTab: eventRecord.secondLeg.flightTypeTab ? eventRecord.secondLeg.flightTypeTab.secondLeg : 0,
                            input_directFlight_FlightNo: eventRecord.secondLeg.flightNo ? eventRecord.secondLeg.flightNo : '', // directFlight
                            input_directFlight_AtcCallSign: eventRecord.secondLeg.atcCallSign ? eventRecord.secondLeg.atcCallSign : '',
                            input_directFlight_AirportDeparture: eventRecord.secondLeg.aptFrom ? eventRecord.secondLeg.aptFrom : '',
                            input_directFlight_AirportDestination: eventRecord.secondLeg.aptTo ? eventRecord.secondLeg.aptTo : '',

                            input_viaFlight_FlightNo: eventRecord.secondLeg.flightNo, // viaFlight
                            input_viaFlight_AtcCallSign: eventRecord.secondLeg.atcCallSign,
                            input_viaFlight_AirportDeparture: eventRecord.secondLeg.aptFrom,
                            input_viaFlight_AirportVia: eventRecord.secondLeg.aptVIA,
                            input_viaFlight_AirportDestination: eventRecord.secondLeg.aptTo, // reversed to keep code simple TODO:

                            input_triaFlight_FlightNo: '', // triaFlight
                            input_triaFlight_AtcCallSign: '',
                            input_triaFlight_FlightNoVia: '',
                            input_triaFlight_AtcCallSignVia: '',
                            input_triaFlight_AirportDestinationDeparture: '',
                            input_triaFlight_AirportFirstVia: '',
                            input_triaFlight_AirportSecondVia: '',

                            input_AB_Time_Departure_Actual: eventRecord.secondLeg.AB_departureTime ? dayjs(eventRecord.secondLeg.AB_departureTime).utc().format('HH:mm') : null, // >>> --- AB
                            input_AB_Time_Arrival_Actual: eventRecord.secondLeg.arrivalTime ? dayjs(eventRecord.secondLeg.arrivalTime).utc().format('HH:mm') : null,
                            input_AB_Time_Departure_Scheduled: eventRecord.secondLeg.dep_sch_time ? dayjs(eventRecord.secondLeg.dep_sch_time).utc().format('HH:mm') : null,
                            input_AB_Time_Arrival_Scheduled: eventRecord.secondLeg.arr_sch_time ? dayjs(eventRecord.secondLeg.arr_sch_time).utc().format('HH:mm') : null,
                            input_AB_Slot_Departure: eventRecord.secondLeg.dep_slt_time ? dayjs(eventRecord.secondLeg.dep_slt_time).utc().format('HH:mm') : null,
                            input_AB_Slot_Arrival: eventRecord.secondLeg.arr_slt_time ? dayjs(eventRecord.secondLeg.arr_slt_time).utc().format('HH:mm') : null,
                            input_AB_Departure_SlotStatus: eventRecord.secondLeg.depSlotStatus,
                            input_AB_Arrival_SlotStatus: eventRecord.secondLeg.arrSlotStatus,

                            input_BC_Time_Departure_Actual: eventRecord.secondLeg.BC_departureTime ? dayjs(eventRecord.secondLeg.BC_departureTime).utc().format('HH:mm') : null, // >>> --- BC
                            input_BC_Time_Arrival_Actual: eventRecord.secondLeg.BC_arrivalTime ? dayjs(eventRecord.secondLeg.BC_arrivalTime).utc().format('HH:mm') : null,
                            input_BC_Time_Departure_Scheduled: eventRecord.secondLeg.BC_dep_sch_time ? dayjs(eventRecord.secondLeg.BC_dep_sch_time).utc().format('HH:mm') : null,
                            input_BC_Time_Arrival_Scheduled: eventRecord.secondLeg.BC_arr_sch_time ? dayjs(eventRecord.secondLeg.BC_arr_sch_time).utc().format('HH:mm') : null,
                            input_BC_Slot_Departure: eventRecord.secondLeg.BC_dep_slt_time  ? dayjs(eventRecord.secondLeg.BC_dep_slt_time).utc().format('HH:mm') : null,
                            input_BC_Slot_Arrival: eventRecord.secondLeg.BC_arr_slt_time ? dayjs(eventRecord.secondLeg.BC_arr_slt_time).utc().format('HH:mm') : null,
                            input_BC_Departure_SlotStatus: eventRecord.secondLeg.BC_depSlotStatus,
                            input_BC_Arrival_SlotStatus: eventRecord.secondLeg.BC_arrSlotStatus,

                            input_CA_Time_Departure_Actual: null, // >>> --- CA
                            input_CA_Time_Arrival_Actual: null,
                            input_CA_Time_Departure_Scheduled: null,
                            input_CA_Time_Arrival_Scheduled: null,
                            input_CA_Slot_Departure: null,
                            input_CA_Slot_Arrival: null,
                            input_CA_Departure_SlotStatus: null,
                            input_CA_Arrival_SlotStatus: null,

                            input_overnight: eventRecord.secondLeg.overnight ? eventRecord.secondLeg.overnight : false, // >>> --- OVERNIGHT

                            input_Switch_FlightOverNight: false, // >>> --- SWITCHES
                            input_Switch_CheckIn: false,
                            input_Switch_CheckOut: false
                        },
                        missingBlocktimes: [],
                        idCreationChain: eventRecord.secondLeg.idCreationChain
                    },
                    validation: { step1: true, step2: true, step3: true },
                    activeStepper: '3',
                    inputsAreDirty: false
                });

            }, // eof onAssign_Update()


            // #   /$$$$$$$  /$$$$$$$$  /$$$$$$  /$$$$$$$$/$$$$$$$$
            // #  | $$__  $$| $$_____/ /$$__  $$| $$_____/__  $$__/
            // #  | $$  \ $$| $$      | $$  \__/| $$        | $$
            // #  | $$$$$$$/| $$$$$   |  $$$$$$ | $$$$$     | $$
            // #  | $$__  $$| $$__/    \____  $$| $$__/     | $$
            // #  | $$  \ $$| $$       /$$  \ $$| $$        | $$
            // #  | $$  | $$| $$$$$$$$|  $$$$$$/| $$$$$$$$  | $$
            // #  |__/  |__/|________/ \______/ |________/  |__/
            // #
            // #
            // #
            /*******************************************************************
            * onAssign_Reset()
            *
            * Desc: Resets CrudData.
            * Note:
            *
            */
            onAssign_Reset: function() {

                const me = this;


                me.$toc('>>> views/shared/components/core/BottomSheet.vue >>> onAssign_Reset');
                Object.assign(me, {
                    // >>> ------------------------------------ 'CRUD Config'
                    // >>> ------------------------------------ 'CRUD Config'
                    crudData: {
                        firstLeg: {
                            input_FlightId: '',
                            // >>> Step 1: 'Flight Config' --------------
                            input_AircraftConfig: '',
                            input_FlightModus: null,
                            input_CodeShare: '',
                            input_Range: 'SHORT',
                            input_ServiceFlags: [],
                            input_FlightComment: '',
                            input_PermissionNumber: '',
                            input_MainServiceType: '',

                            // >>> Step 2: 'Date Config' ----------------
                            input_FlightDateType: 0,
                            input_weekly_DaysOfWeek: [],
                            input_dates_dates: [],
                            input_weekly_StartDate: '',
                            input_weekly_EndDate: '',
                            input_weekly_NumberOfWeeks: [],

                            weekly_datesInRange: {
                                total: 0,
                                weeks: 0,
                                dates: [],
                                months: []
                            },

                            // >>> Step 3: 'Route Config' ---------------
                            input_FlightTypeTab: 0,
                            input_directFlight_FlightNo: '', // directFlight
                            input_directFlight_AtcCallSign: '',
                            input_directFlight_AirportDeparture: '',
                            input_directFlight_AirportDestination: '',

                            input_viaFlight_FlightNo: '', // viaFlight
                            input_viaFlight_AtcCallSign: '',
                            input_viaFlight_AirportDeparture: '',
                            input_viaFlight_AirportVia: '',
                            input_viaFlight_AirportDestination: '',

                            input_triaFlight_FlightNo: '', // triaFlight
                            input_triaFlight_AtcCallSign: '',
                            input_triaFlight_FlightNoVia: '',
                            input_triaFlight_AtcCallSignVia: '',
                            input_triaFlight_AirportDestinationDeparture: '',
                            input_triaFlight_AirportFirstVia: '',
                            input_triaFlight_AirportSecondVia: '',

                            input_AB_Time_Departure_Actual: null, // >>> --- AB
                            input_AB_Time_Arrival_Actual: null,
                            input_AB_Time_Departure_Scheduled: null,
                            input_AB_Time_Arrival_Scheduled: null,
                            input_AB_Slot_Departure: null,
                            input_AB_Slot_Arrival: null,

                            input_BC_Time_Departure_Actual: null, // >>> --- BC
                            input_BC_Time_Arrival_Actual: null,
                            input_BC_Time_Departure_Scheduled: null,
                            input_BC_Time_Arrival_Scheduled: null,
                            input_BC_Slot_Departure: null,
                            input_BC_Slot_Arrival: null,

                            input_CA_Time_Departure_Actual: null, // >>> --- CA
                            input_CA_Time_Arrival_Actual: null,
                            input_CA_Time_Departure_Scheduled: null,
                            input_CA_Time_Arrival_Scheduled: null,
                            input_CA_Slot_Departure: null,
                            input_CA_Slot_Arrival: null,

                            input_overnight: false, // >>> --- OVERNIGHT

                            input_Switch_FlightOverNight: false, // >>> --- SWITCHES
                            input_Switch_CheckIn: false,
                            input_Switch_CheckOut: false,

                            input_idStartSegment: null // >>> --- FlightGroud
                        },
                        secondLeg: {
                            // >>> Step 1: 'Flight Config' --------------
                            input_AircraftConfig: '',
                            input_FlightModus: null,
                            input_CodeShare: '',
                            input_Range: 'SHORT',
                            input_ServiceFlags: [],
                            input_FlightComment: '',
                            input_PermissionNumber: '',
                            input_MainServiceType: '',

                            // >>> Step 2: 'Date Config' ----------------
                            input_FlightDateType: 0,
                            input_weekly_DaysOfWeek: [],
                            input_dates_dates: [],
                            input_weekly_StartDate: '',
                            input_weekly_EndDate: '',
                            input_weekly_NumberOfWeeks: [],

                            weekly_datesInRange: {
                                total: 0,
                                weeks: 0,
                                dates: [],
                                months: []
                            },

                            // >>> Step 3: 'Route Config' ---------------
                            input_FlightTypeTab: 0,
                            input_directFlight_FlightNo: '', // directFlight
                            input_directFlight_AtcCallSign: '',
                            input_directFlight_AirportDeparture: '',
                            input_directFlight_AirportDestination: '',

                            input_viaFlight_FlightNo: '', // viaFlight
                            input_viaFlight_AtcCallSign: '',
                            input_viaFlight_AirportDeparture: '',
                            input_viaFlight_AirportVia: '',
                            input_viaFlight_AirportDestination: '',

                            input_triaFlight_FlightNo: '', // triaFlight
                            input_triaFlight_AtcCallSign: '',
                            input_triaFlight_FlightNoVia: '',
                            input_triaFlight_AtcCallSignVia: '',
                            input_triaFlight_AirportDestinationDeparture: '',
                            input_triaFlight_AirportFirstVia: '',
                            input_triaFlight_AirportSecondVia: '',

                            input_AB_Time_Departure_Actual: null, // >>> --- AB
                            input_AB_Time_Arrival_Actual: null,
                            input_AB_Time_Departure_Scheduled: null,
                            input_AB_Time_Arrival_Scheduled: null,
                            input_AB_Slot_Departure: null,
                            input_AB_Slot_Arrival: null,

                            input_BC_Time_Departure_Actual: null, // >>> --- BC
                            input_BC_Time_Arrival_Actual: null,
                            input_BC_Time_Departure_Scheduled: null,
                            input_BC_Slot_Departure: null,
                            input_BC_Time_Arrival_Scheduled: null,
                            input_BC_Slot_Arrival: null,

                            input_CA_Time_Departure_Actual: null, // >>> --- CA
                            input_CA_Time_Arrival_Actual: null,
                            input_CA_Time_Departure_Scheduled: null,
                            input_CA_Time_Arrival_Scheduled: null,
                            input_CA_Slot_Departure: null,
                            input_CA_Slot_Arrival: null,

                            input_overnight: false, // >>> --- OVERNIGHT

                            input_Switch_FlightOverNight: false, // >>> --- SWITCHES
                            input_Switch_CheckIn: false,
                            input_Switch_CheckOut: false,

                            input_nextDay: false
                        },
                        missingBlocktimes: []
                    },
                    //validation: { step1: true, step2: true, step3: true },
                    activeStepper: '3',
                    inputsAreDirty: false
                });

            }, // eof onAssign_Reset()


            //-----------------------------------------------------------------/
            // #
            // #   /$$    /$$          /$$ /$$       /$$             /$$     /$$
            // #  | $$   | $$         | $$|__/      | $$            | $$    |__/
            // #  | $$   | $$ /$$$$$$ | $$ /$$  /$$$$$$$  /$$$$$$  /$$$$$$   /$$  /$$$$$$  /$$$$$$$
            // #  |  $$ / $$/|____  $$| $$| $$ /$$__  $$ |____  $$|_  $$_/  | $$ /$$__  $$| $$__  $$
            // #   \  $$ $$/  /$$$$$$$| $$| $$| $$  | $$  /$$$$$$$  | $$    | $$| $$  \ $$| $$  \ $$
            // #    \  $$$/  /$$__  $$| $$| $$| $$  | $$ /$$__  $$  | $$ /$$| $$| $$  | $$| $$  | $$
            // #     \  $/  |  $$$$$$$| $$| $$|  $$$$$$$|  $$$$$$$  |  $$$$/| $$|  $$$$$$/| $$  | $$
            // #      \_/    \_______/|__/|__/ \_______/ \_______/   \___/  |__/ \______/ |__/  |__/
            // #
            //-----------------------------------------------------------------/
            /*******************************************************************
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onValidate_Form{}
            *
            * Desc:
            * Note:
            *
            */
            onValidate_Form: function() {

                const me = this;


                me.$toc('>>> views/shared/components/core/BottomSheet.vue >>> onValidate_Form');
                me.validateFormStepper('1');
                me.validateFormStepper('2');
                me.validateFormStepper('3');

                if (!me.get_Shared_isUserAllowedToUse('READONLY') && me.get_Shared_isUserAllowedToUse('ADMIN')) {
                    me.checkForMissingBlocktimes();
                }

                if (this.$refs.form.validate() === false) {
                    return;
                }

                if (me.crudData.missingBlocktimes.length > 0) {
                    me.actn_set_warning({
                        title: 'Missing Blocktimes found',
                        text: `
                                    <h3 style="padding-bottom:28px">Do you want to add the following missing Blocktimes?</h3>

                                        <div style="display:flex;">
                                            <div style="padding-top:0;flex: 0 0 110px;">Departure Airport</div>
                                            <div style="padding-top:0;flex: 1;">Destination Airport.</div>
                                            <div style="padding-top:0;flex: 1;">Blocktime</div>
                                        </div>
                                        ${me.crudData.missingBlocktimes.map(p => `
                                            <div style="display:flex;border-top: 1px solid #757575;">
                                                <div style="padding-top:4px;flex: 0 0 110px;">${p.aptFromCode}</div>
                                                <div style="padding-top:4px;flex: 1;">${p.aptToCode}</div>
                                                <div style="padding-top:4px;flex: 1;color:green;">${p.blockTime} hrs</div>
                                            </div>
                                        `).join(' ')}
                                `,
                        payload: me.crudData.missingBlocktimes,
                        acceptFunction: () => {
                            me.actn_call_updateCreateBlocktimes({ blockTimes: me.crudData.missingBlocktimes });
                            me.onValidated_Form_CallAction();
                        },
                        declineFunction: () => {
                            me.onValidated_Form_CallAction();
                        }
                    });
                } else {
                    me.onValidated_Form_CallAction();
                }

            }, // eo function onValidate_Form()


            /*******************************************************************
            * onValidated_Form_CallAction()
            *
            * Desc: Shoots Action Calls based on editorMode AFTER validation.
            * Note:
            *
            */
            onValidated_Form_CallAction: function() {

                const me = this;


                me.$toc('>>> views/shared/components/core/BottomSheet.vue >>> onValidated_Form_CallAction');
                if (me.editorMode === 'update') {
                    me.actn_call_slotmanagement_updateFlights(me.createUpdateFlightsPayload());
                }

            }, // eo function onValidated_Form_CallAction()


            /*******************************************************************
            * onClick_StepperHeader()
            *
            * Desc: Validate leaved Stepper Content, set new active Stepper.
            * Note: First validate the activeStepper, but only if it was
            * Note: validated as FALSE before.
            *
            */
            onClick_StepperHeader: function(stepperNumber) {

                const me = this;


                me.$toc('>>> views/shared/components/core/BottomSheet.vue >>> onClick_StepperHeader');
                //window.dispatchEvent(new Event('resize'));

                switch (me.activeStepper) {
                    case '1':
                        if (me.validation.step1 === false) {
                            me.validateFormStepper('1');
                        }
                        break;
                    case '2':
                        if (me.validation.step2 === false) {
                            me.validateFormStepper('2');
                        }
                        break;
                    case '3':
                        if (me.validation.step3 === false) {
                            me.validateFormStepper('3');
                        }
                        break;
                    default: break;
                }

                me.activeStepper = stepperNumber;

            }, // eo function onClick_StepperHeader()


            /*******************************************************************
            * validateInputFields()
            *
            * Desc: Identify an element as INPUT.
            * Note: Check ELEMENT of being an input field.
            * Note: It is an input field if the key "type" exists in this
            * Note: object. ('type' in element)
            * Note: If this object does not have this "type" key, look up
            * Note: the children of this ELEMENT recursivly.
            *
            * @param {Object} element
            * @returns {Object | null}
            */
            validateInputFields: function(element) {

                const me = this;
                let valid = true;


                me.$toc('>>> views/shared/components/core/BottomSheet.vue >>> validateInputFields');
                if ('type' in element) { // ;-)
                    return element.valid !== undefined ? element.valid : true;
                } else {
                    if (element.$children.length > 0) {
                        element.$children.forEach(child => {
                            valid = valid && this.validateInputFields(child);
                        });
                    }
                }


                return valid;

            }, // eo function validateInputFields()


            /*******************************************************************
            * validateFormStepper()
            *
            * Desc: Validate a single Steppers inputs.
            * Note: Get all children of a Stepper with a ref.
            * Note: Loop over the children and identify them as input fields,
            * Note: after that check for the VALID key.
            * Note: Step 2 is disabled on "update" mode. So we have to skip
            * Note: step 2 validation on update (ref is undefined).
            *
            * @param {Number} stepperNumber
            * @returns {Boolean}
            */
            validateFormStepper: function(stepperNumber) {

                const me = this;
                let stepperIsValid = true,
                    child = null,
                    stepperRef = null;


                me.$toc('>>> views/shared/components/core/BottomSheet.vue >>> validateFormStepper');
                switch (stepperNumber) {
                    case '1':
                        stepperRef = this.$refs.stepperContent1;
                        break;
                    case '2':
                        stepperRef = this.$refs.stepperContent2;
                        break;
                    case '3':
                        stepperRef = this.$refs.stepperContent3;
                        break;
                    default:
                        stepperRef = null;
                        break;
                }

                // clean up
                if (stepperRef === undefined) {
                    stepperRef = null;
                }


                if (stepperRef !== null) {
                    for (let i = 0; i < stepperRef.$children.length; i++) {
                        child = stepperRef.$children[i];

                        stepperIsValid = this.validateInputFields(child);
                    }
                }


                switch (stepperNumber) {
                    case '1':
                        this.validation.step1 = stepperIsValid;
                        break;
                    case '2':
                        this.validation.step2 = stepperIsValid;
                        break;
                    case '3':
                        this.validation.step3 = stepperIsValid;
                        break;
                    default:
                        break;
                }


                return stepperIsValid;

            }, // eo function validateFormStepper()


            /*******************************************************************
            * checkForMissingBlocktimes()
            *
            * Desc: Checks for available blocktimes for the entered Airport Pair
            * Note: pairedInputs is an Array config for the different flightTypeTap (DIRECT, VIA, TRIA) input fields..
            * Note: Based on the value of a certain input field
            *
            */
            checkForMissingBlocktimes: function() {

                const me = this,
                    missingBlocktimes = [],
                    editorFlightLegMode = me.editorFlightLegMode,
                    legs = editorFlightLegMode === 'single' ? 1 : 2,
                    pairedInputs = {
                        0: [
                            {
                                aptFromCode: 'input_directFlight_AirportDeparture',
                                aptToCode: 'input_directFlight_AirportDestination',
                                fromTime: 'input_AB_Time_Departure_Scheduled',
                                toTime: 'input_AB_Time_Arrival_Scheduled'
                            }
                        ],
                        1: [
                            {
                                aptFromCode: 'input_viaFlight_AirportDeparture',
                                aptToCode: 'input_viaFlight_AirportVia',
                                fromTime: 'input_AB_Time_Departure_Scheduled',
                                toTime: 'input_AB_Time_Arrival_Scheduled'
                            },
                            {
                                aptFromCode: 'input_viaFlight_AirportVia',
                                aptToCode: 'input_viaFlight_AirportDestination',
                                fromTime: 'input_BC_Time_Departure_Scheduled',
                                toTime: 'input_BC_Time_Arrival_Scheduled'
                            }
                        ],
                        2: [
                            {
                                aptFromCode: 'input_triaFlight_AirportDestinationDeparture',
                                aptToCode: 'input_triaFlight_AirportFirstVia',
                                fromTime: 'input_AB_Time_Departure_Scheduled',
                                toTime: 'input_AB_Time_Arrival_Scheduled'
                            },
                            {
                                aptFromCode: 'input_triaFlight_AirportFirstVia',
                                aptToCode: 'input_triaFlight_AirportSecondVia',
                                fromTime: 'input_BC_Time_Departure_Scheduled',
                                toTime: 'input_BC_Time_Arrival_Scheduled'
                            },
                            {
                                aptFromCode: 'input_triaFlight_AirportSecondVia',
                                aptToCode: 'input_triaFlight_AirportDestinationDeparture',
                                fromTime: 'input_CA_Time_Departure_Scheduled',
                                toTime: 'input_CA_Time_Arrival_Scheduled'
                            }
                        ]
                    };

                let currentLeg = '',
                    foundBlocktime = {},
                    newBlocktime = {};
                    currentLeg = '';


                me.$toc('>>> views/shared/components/core/BottomSheet.vue >>> checkForMissingBlocktimes');
                for (let x = 0; x < legs; x++) {

                    if (x === 0) {
                        currentLeg = 'firstLeg';
                    } else {
                        currentLeg = 'secondLeg';
                    }

                    pairedInputs[me.crudData[currentLeg].input_FlightTypeTab].forEach((pairedInput) => {

                        // guard clause
                        if (Vue.prototype.$isEmpty(me.crudData[currentLeg][pairedInput.aptFromCode]) ||
                            Vue.prototype.$isEmpty(me.crudData[currentLeg][pairedInput.aptToCode])) {
                            return;
                        }

                        // try to find existing blocktimes
                        foundBlocktime = me.get_Blocktimes.find(blocktime =>
                            blocktime.aptFromCode === me.crudData[currentLeg][pairedInput.aptFromCode].aptCode &&
                            blocktime.aptToCode === me.crudData[currentLeg][pairedInput.aptToCode].aptCode
                        );

                        // No Blocktime found? -> create new Blocktime based on inputs
                        if (Vue.prototype.$isEmpty(foundBlocktime)) {
                            const [fromHr, fromMin] = me.crudData[currentLeg][pairedInput.fromTime].split(':');
                            const [toHr, toMin] = me.crudData[currentLeg][pairedInput.toTime].split(':');
                            const blockTime = dayjs(dayjs().hour(toHr).minute(toMin).second(0).startOf('minute').diff(dayjs().hour(fromHr).minute(fromMin).second(0).startOf('minute'))).utc().format('HH:mm');

                            newBlocktime = {
                                id: null, // see Note
                                aptFromCode: me.crudData[currentLeg][pairedInput.aptFromCode].aptCode,
                                aptToCode: me.crudData[currentLeg][pairedInput.aptToCode].aptCode,
                                blockTime: blockTime
                            };
                            missingBlocktimes.push(newBlocktime);
                        }
                    });

                }

                me.crudData.missingBlocktimes = missingBlocktimes;

            } // eo function checkForMissingBlocktimes()

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>

<style scoped>
    .v-dialog > .v-card > .v-card__actions {
        padding: 10px 10px;
    }

    .v-card__subtitle, .v-card__text {
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.375rem;
        letter-spacing: 0.0071428571em;
    }

    .v-stepper__content {
        /* max-height:700px; */
        overflow-y:scroll;
    }

    .v-stepper__content h2 {
        font-weight:500;
        margin-top:24px;
        font-size: 1.2em;
    }

    .v-stepper__content .input-row:not(:first-child) {
        border-top:1px solid lightgrey;
        margin-top:24px;
    }


    .sdr-custom-tab-active {
        color: #AB3B7A !important;
    }

    .sdr-custom-tabs .v-item-group {
        padding-left: 0;
    }

</style>

<style>

    @keyframes glowing {
        0% { box-shadow: 0 0 -10px #82A683; transform: scale(1); }
        40% { box-shadow: 0 0 20px #82A683; transform: scale(1.1); }
        60% { box-shadow: 0 0 20px #82A683; transform: scale(1.1); }
        100% { box-shadow: 0 0 -10px #82A683; transform: scale(1); }
    }

    .input-glow {
        animation: glowing 1500ms 1;
    }

    /* BottomSheet Wide Classes to get responsibility */
    .smallDisplay .container {
        max-width: 100vw !important;
    }
    /* BottomSheet Wide Classes to get responsibility */

    .v-dialog:not(.v-dialog--fullscreen) {
        max-height: 90%;
    }

</style>
